const NAME = "MY_REQUESTS_MANAGER_PAGE";

export default NAME;
